<template>
    <div class="record_box">
      <div class="Invoicingbtn" > <span class="btn" @click="goInvoicingList">去开票</span> </div>
      <scroll 
        class="scroll"
        :objData="dataList"
        :allLoaded="allLoaded"
        @pulldown="loadData"
        v-if="dataList.length > 0 && showPage"
      >
        
        <section class="data_list" v-for="(item,key) in dataList" :key="key">
          <div class="lineItem">
                <div class="lineLeft">停车场</div>
                <div class="lineRight">{{item.parkName}}</div>
          </div>
          <div class="lineItem">
            <div class="lineLeft">所属项目</div>
            <div class="lineRight">{{item.subProjectName}}</div>
          </div>
          <div class="lineItem">
            <div class="lineLeft">缴费月数</div>
            <div class="lineRight">{{item.monthCount}}个月  ({{item.startDay | dateFormat}}  -  {{item.endDay |dateFormat}})</div>
          </div>
          <div class="lineItem">
            <div class="lineLeft">缴费日期</div>
            <div class="lineRight">{{item.payAt}}</div>
          </div>
          <div class="payAmountText">
            <p>{{item.payAmount|priceFormat}}</p>
          </div>
        </section>
      </scroll>
      <no-message v-if="dataList.length<=0 && showPage"></no-message>
    </div>
    </template>
    
    <script>
    import util from '../../utils/util';
    import Scroll from "../../components/scroll";
    import {loadParkHeaderById,checkOpenReceipt} from '../../utils/api';
    import {mapState} from 'vuex';
    import storage from '../../utils/storage';
    import NoMessage from "../../components/nomessage";
    export default {
      name: 'historyBill',
      props: {},
      components: {
        Scroll,
        NoMessage
      },
      filters: {
        timeType(val){
           if(!val) return '' 
          let {year,month} = util.formatTime(new Date(),17);
          if(val.slice(0,4) == year && val.slice(5,7)==month){
            return '本月'
          }else {
            return val
          }
        },
        dateFormat(val){
          if(!val) return ''
          return val.slice(0,10)
        },
      },
      computed: {
        ...mapState({
          common: state => state.common
        })
      },
      data() {
        return {
          dataList:[1,2,3],
          newObj:{},
          allLoaded:true,
          pullup:false,
          showPage:false
        }
      },
      created() {
         this.queryHistoryBill()
      },
      mounted(){
      },
      methods: {
        // 下拉刷新
        loadData() {
          this.pageNo = 1;
          util.showLoading();
          this.queryHistoryBill();
        },
        queryHistoryBill(){
          util.showLoading()
          let params = {
            userId:this.common.userId,
            subProjectId:this.common.marketInfo.id,
            url:"/parking/rstParkLot/queryHistoryBill"
          }
          loadParkHeaderById(params).then(res=>{
            util.hideLoading()
            this.showPage = true;
            if(res.res.code === 10000 && res.body && res.body.data){
              let dataList = res.body.data.data || [];
              this.dataList = dataList;
            }else{
              util.showToast(res.res.msg)
            }
          })
        },
        toDetail(item){
          storage.set('recordItem',JSON.stringify(item))
          this.$router.push(`/paymentRecordDetail`)
        },
        goInvoicingList(){
              var type = 4; 
              let params = {
                  marketId:this.common.marketInfo.id,
                   'orderType':String(type)
                };
                util.showLoading("加载中...");
                checkOpenReceipt(params).then(res => {
                    console.log(res);
                    util.hideLoading();
                    var isOpen  =false;
                    if(res.res.code ==10000 && res.body){
                        isOpen = res.body.isOpen;
                    }
                    if(isOpen){
                        var url ='/InvoicingList?viewType=' + type;
                        this.$router.push({path:url});
                    }else{
                        if(res.res.code !=10004){
                          util.showToast(res.res.msg);
                        }
                        
                    }

                });
        }
      }
    };
    </script>
    <style lang="less" scoped>
    @import "../../assets/css/common.less";
    .record_box{
      background:#eee;
      height:100vh;
     
    }
    .Invoicingbtn{
      margin: 20px;
      width: 710px;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      .btn{
        width: 180px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        background:#0087ff;
        border-radius:8px;
        font-size:28px;
        color:#ffffff;
      }
    }
    .scroll{
      height: calc(100vh - 100px);
    }
    .data_list{
        background:#fff;
        margin-left: 20px;
        margin-right: 20px;
        margin-bottom: 20px;

        border-radius: 8px;
        overflow: hidden;
        position: relative;
        padding-bottom: 10px;
      }
      .lineItem{
        width: 100%;
        margin-top: 10px;
        flex-direction: row;
        display: flex;
      }
      .lineLeft{

        width: 140px;
        margin-left: 15px;
        font-size:28px;
        color:rgba(153,153,153,1);
        line-height:40px;
        display: flex;
      }
      .lineRight{
        width: 525px;
        margin-left: 15px;
        font-size:28px;
        color:rgba(51,51,51,1);
        line-height:40px;
        display: flex;
      }
      .payAmountText{
        position: absolute;
        right: 30px;
        bottom: 15px;;
        font-size:32px;
        font-weight:bold;
        color:rgba(51,51,51,1);
        line-height:40px;

      }
    </style>
    